(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-sku"] && !Shopify.designMode) return;
  try {
    class ProductSku extends HTMLElement {
    constructor() {
      super();
      // Store bound function reference for proper cleanup
      this.boundHandleVariantUpdate = this.handleVariantUpdate.bind(this);
      this.init();
    }

    init() {
      // Listen for variant update events
      document.addEventListener('variant:update', this.boundHandleVariantUpdate);
    }

    /**
     * Handles the variant update event from the variant picker
     * @param {CustomEvent} event - The variant update event
     */
    handleVariantUpdate(event) {
      if (!event.detail?.resource) return;
      
      const variant = event.detail.resource;
      const skuElement = this.querySelector('[data-product-sku]');
      
      if (skuElement && variant.sku) {
        skuElement.textContent = variant.sku;
      } else if (skuElement && !variant.sku) {
        // Hide the SKU if the variant doesn't have one
        skuElement.textContent = '';
      }
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.boundHandleVariantUpdate);
    }
  }

  if (!customElements.get('product-sku')) {
    customElements.define('product-sku', ProductSku);
  }
  } catch(e) { console.error(e); }
})();

})();
